import { IconProps } from '../types';

function AxisSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M18,17c0,.55-.45,1-1,1H3c-.55,0-1-.45-1-1V3c0-.55.45-1,1-1s1,.45,1,1v13h13c.55,0,1,.45,1,1ZM6,15c.26,0,.51-.1.71-.29l2-2c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-2,2c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29ZM10,11c.26,0,.51-.1.71-.29l2-2c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-2,2c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default AxisSolidIcon;
